// extracted by mini-css-extract-plugin
module.exports = {"bannerJobRemoved":"dismiss_bannerJobRemoved__H7LnF","fadeIn":"dismiss_fadeIn__SEeOM","clickedLink":"dismiss_clickedLink__DHHAF"};